import { LOAD_CANDIDATOS, LOAD_VOTOS, RESET_ELEICOES } from '.'

const INITIAL_STATE = []
export const mutations = {
  [LOAD_CANDIDATOS]: (state, payload) => {
    state.candidatos = payload
  },
  [LOAD_VOTOS]: (state, payload) => {
    state.votos = payload
  },
  [RESET_ELEICOES]: state => {
    state.candidatos = INITIAL_STATE
    state.votos = INITIAL_STATE
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/eleicoes_conselho/mutations.js